/**
 * If the provider has disabled a sound effect in their 'notifications' settings,
 * model this with the NO_SOUND symbol instead of undefined.
 * Undefined means we don't know the user's preference.
 */
export const NO_SOUND = Symbol('NO_SOUND');

export enum AudioFile {
  CallStart_Doorbell = 'callStart_doorbell',
  CallStart_Tada = 'callStart_tada',
  CallStart_Chime = 'callStart_chime',
  MessageReceived = 'messageReceived',
  DoneDeal = 'doneDeal',
  Hammered = 'hammered',
  Likeable = 'likeable',
  Waitingfor = 'waitingfor',
  WakeupCall = 'wakeupCall',
}

export const AudioCatalogue = {
  [AudioFile.CallStart_Doorbell]: 'callstart-doorbell.mp3',
  [AudioFile.CallStart_Tada]: 'callstart-tada.mp3',
  [AudioFile.CallStart_Chime]: 'callstart-chime.mp3',
  [AudioFile.MessageReceived]: 'done-deal.mp3',
  [AudioFile.DoneDeal]: 'done-deal.mp3',
  [AudioFile.Hammered]: 'hammered.mp3',
  [AudioFile.Likeable]: 'likeable.mp3',
  [AudioFile.Waitingfor]: 'waitingfor.mp3',
  [AudioFile.WakeupCall]: 'wakeup-call.mp3',
};
